import React, { useState, useEffect } from "react";
import { db } from "../../utils/firebase";
import { collection, getDocs, deleteDoc, doc, setDoc } from "firebase/firestore";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import './UserArchive.css'; // Custom styles
import { Link, useLocation } from 'react-router-dom';

const AnnouncementArchive = () => {
  const [archivedAnnouncements, setArchivedAnnouncements] = useState([]);
  const location = useLocation();

  // Fetch archived announcements
  useEffect(() => {
    const fetchArchivedAnnouncements = async () => {
      try {
        const snapshot = await getDocs(collection(db, "announcements_archive"));
        const announcements = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setArchivedAnnouncements(announcements);
      } catch (error) {
        console.error("Error fetching archived announcements: ", error);
      }
    };

    fetchArchivedAnnouncements();
  }, []);

  // Restore an archived announcement to the "announcements" collection
  const restoreAnnouncement = async (announcementId) => {
    const announcementToRestore = archivedAnnouncements.find(
      (announcement) => announcement.id === announcementId
    );

    try {
      // Add the announcement back to the "announcements" collection
      await setDoc(doc(db, "announcements", announcementId), announcementToRestore);

      // Delete from "announcements_archive" collection
      await deleteDoc(doc(db, "announcements_archive", announcementId));

      // Update the local state by removing the restored announcement
      setArchivedAnnouncements((prev) =>
        prev.filter((announcement) => announcement.id !== announcementId)
      );
    } catch (error) {
      console.error("Error restoring announcement: ", error);
    }
  };

  
  const deleteAnnouncement = async (announcementId) => {
    try {
      // Delete the announcement from the "announcements_archive" collection
      await deleteDoc(doc(db, "announcements_archive", announcementId));

      // Update the local state by removing the deleted announcement
      setArchivedAnnouncements((prev) =>
        prev.filter((announcement) => announcement.id !== announcementId)
      );
    } catch (error) {
      console.error("Error deleting announcement: ", error);
    }
  };

  return (
    <div className="admin-page">
      <Navbar />
      <div className="admin-container">
        <div className="admin-sidebar">
           <h2>Admin Panel</h2>
           <Link to="/adminusers" className={`sidebar-button ${location.pathname === '/adminusers' ? 'active' : ''}`}>Users</Link>
           <Link to="/adminposts" className={`sidebar-button ${location.pathname === '/adminposts' ? 'active' : ''}`}>User Posts</Link>
           <Link to="/adminfeedback" className={`sidebar-button ${location.pathname === '/adminfeedback' ? 'active' : ''}`}>User Feedback</Link>
           <Link to="/announcementadmin" className={`sidebar-button ${location.pathname === '/announcementadmin' ? 'active' : ''}`}>Announcements</Link>
           <Link to="/exploreaboutadmin" className={`sidebar-button ${location.pathname === '/exploreaboutadmin' ? 'active' : ''}`}>Explore about Bacoor</Link>
 
           <h2>Places to Visit</h2>
           <Link to="/bridgesadmin" className={`sidebar-button ${location.pathname === '/bridgesadmin' ? 'active' : ''}`}>Bridges & Dams</Link>
           <Link to="/monumentsadmin" className={`sidebar-button ${location.pathname === '/monumentsadmin' ? 'active' : ''}`}>Monuments & Statues</Link>
           <Link to="/houseadmin" className={`sidebar-button ${location.pathname === '/houseadmin' ? 'active' : ''}`}>Ancestral Houses</Link>
           <Link to="/churchesadmin" className={`sidebar-button ${location.pathname === '/churchesadmin' ? 'active' : ''}`}>Churches & Religious Sites</Link>
 
           <h2>Things to Do</h2>
           <Link to="/recreationaladmin" className={`sidebar-button ${location.pathname === '/recreationaladmin' ? 'active' : ''}`}>Recreational Activities</Link>
           <Link to="/diningadmin" className={`sidebar-button ${location.pathname === '/diningadmin' ? 'active' : ''}`}>Dining and Culinary</Link>
           <Link to="/shoppingadmin" className={`sidebar-button ${location.pathname === '/shoppingadmin' ? 'active' : ''}`}>Shopping and Market</Link>
 
           <h2>Archives</h2>
           <Link to="/userarchive" className={`sidebar-button ${location.pathname === '/userarchive' ? 'active' : ''}`}>Users</Link>
           <Link to="/postsarchive" className={`sidebar-button ${location.pathname === '/postsarchive' ? 'active' : ''}`}>Posts</Link>
           <Link to="/feedbackarchive" className={`sidebar-button ${location.pathname === '/feedbackarchive' ? 'active' : ''}`}>Feedback</Link>
           <Link to="/announcementarchive" className={`sidebar-button ${location.pathname === '/announcementarchive' ? 'active' : ''}`}>Announcements</Link>
         </div>
        <div className="admin-content">
          <h2>Archived Announcements</h2>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Description</th>
                <th>From</th>
                <th>Background</th>
                <th>Images</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {archivedAnnouncements.map((announcement) => (
                <tr key={announcement.id}>
                  <td>{announcement.title}</td>
                  <td>{announcement.description}</td>
                  <td>{announcement.from}</td>
                  <td>
                    <img
                      src={announcement.background}
                      alt="Background"
                      style={{ width: "100px", height: "auto" }}
                    />
                  </td>
                  <td>
                    {announcement.images.map((image, index) => (
                      <img
                        key={index}
                        src={image}
                        alt={`Image ${index}`}
                        style={{ width: "100px", height: "auto" }}
                      />
                    ))}
                  </td>
                  <td>
                    <button className="restore-btn" onClick={() => restoreAnnouncement(announcement.id)}>
                    <i className="bi bi-arrow-clockwise"></i>
                    </button>
                    <button className="delete-btn" onClick={() => deleteAnnouncement(announcement.id)}>
                    <i className="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AnnouncementArchive;
